import { EmployeeCheckinsComponent } from "./checkins/emp-checkins";
import { EmployeeBreaksComponent } from "./breaks/emp-breaks";
import { EmployeeAttendances } from "./attendance/emp-attendance";
import { EmployeeAttendanceRequests } from "./attendance-requests/attendance-requests";

export const AttendanceAndCheckins = () => {
  return (
    <div className="flex flex-col gap-2">
      <h1 className="text-lg font-medium tracking-wide underline underline-offset-2">
        Attendance & Checkins
      </h1>

      <div className="flex flex-wrap gap-6">
        <EmployeeAttendances />

        <EmployeeCheckinsComponent />

        <EmployeeBreaksComponent />

        <EmployeeAttendanceRequests />
      </div>
    </div>
  );
};
